/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { StreamingMarkdownText } from "./StreamingMarkdownText";
import { useAiPromptGenerationStream } from "../../hooks/useAiEventStream";
import { promptGenerationStreamOutputStyles } from "./PromptGenerationStreamOutputStyles";

type PromptGenerationStreamOutputProps = {
  animated?: boolean;
  emptyText?: string;
  sx?: SxProps<Theme>;
};

export function PromptGenerationStreamOutput({
  animated = true,
  emptyText = "",
  sx,
}: PromptGenerationStreamOutputProps) {
  const { text = "", error, isComplete = false, contentType = "markdown" } = useAiPromptGenerationStream();

  const shouldShowEmptyText = text.length === 0 && emptyText.length > 0;
  const shouldRenderHtml = text.length > 0 && contentType === "html";

  return (
    <Box sx={sx}>
      <Stack spacing={1}>
        {error && (
          <Typography variant="body2" color="error">
            <strong>Fehler:</strong> {error}
          </Typography>
        )}

        <Box sx={promptGenerationStreamOutputStyles.textArea}>
          {shouldShowEmptyText && (
            <Box component="span" sx={promptGenerationStreamOutputStyles.shimmerEmptyText}>
              {emptyText}
            </Box>
          )}

          {shouldRenderHtml ? (
            <Box sx={promptGenerationStreamOutputStyles.htmlText} dangerouslySetInnerHTML={{ __html: text }} />
          ) : (
            <StreamingMarkdownText text={text} animated={animated && !isComplete} emptyText="" />
          )}
        </Box>
      </Stack>
    </Box>
  );
}
